var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center gap-1"},[(_vm.value)?_c('img',{attrs:{"src":require("@/assets/icons/radio_on.svg")}}):_c('img',{attrs:{"src":require("@/assets/icons/radio_off.svg")}}),(!!_vm.label)?_c('p',{staticClass:"flex-1"},[_vm._v(_vm._s(_vm.label))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }